import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { formatNumberForEnrollmentConversionReporting, formatPercentageForEnrollmentConversionReporting } from 'automation-ui-canvas/containers/enrollment-conversion/enrollmentConversionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentConversionPanelCompletedRow = ({
  nodeId,
  isReportingEnabled,
  actionCardCounters,
  enrollmentConversionData
}) => {
  var _endActionCounts$work, _conversionReport$tot;
  const conversionReport = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport;
  const endActionCounts = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.actionStatusCounts[nodeId];
  const actionBranchCount = (_endActionCounts$work = endActionCounts === null || endActionCounts === void 0 ? void 0 : endActionCounts.workflowCompleted) !== null && _endActionCounts$work !== void 0 ? _endActionCounts$work : 0;
  const totalEnrollmentCount = (_conversionReport$tot = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.totalEnrollmentCount) !== null && _conversionReport$tot !== void 0 ? _conversionReport$tot : 0;
  const percentage = totalEnrollmentCount !== 0 ? actionBranchCount / totalEnrollmentCount * 100 : 0;
  const actionCardNumber = actionCardCounters[nodeId];
  return /*#__PURE__*/_jsx(UITooltip, {
    title: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation.enrollmentConversion.panel.tooltips.end",
      options: {
        value: formatNumberForEnrollmentConversionReporting(actionBranchCount),
        total: formatNumberForEnrollmentConversionReporting(totalEnrollmentCount)
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentConversion.panel.endsTable.defaultState.tooltip"
    }),
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: actionCardNumber ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'automation.enrollmentConversion.panel.end.endMarkerText',
            options: {
              nodeId: actionCardNumber
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'automation.enrollmentConversion.panel.end.emptyEndMarkerText'
          })
        })
      }), /*#__PURE__*/_jsx("td", {
        className: "text-right",
        children: isReportingEnabled ? formatPercentageForEnrollmentConversionReporting(percentage) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.panel.endsTable.defaultState.ended"
        })
      })]
    })
  });
};
export default EnrollmentConversionPanelCompletedRow;